import { GetAllNotificationStatusDTO, GetAllNotificationStatusFiltersDTO, NotificationStatusDTO, NotificationStatusUpdateDTO } from "./dto";
import { NotificationStatusServiceImpl } from "./serviceImpl";

export interface NotificationStatusService {
    UpdateNotificationStatus(data: NotificationStatusUpdateDTO, id: string): Promise<void>
    GetAllNotificationStatus(filters: GetAllNotificationStatusFiltersDTO): Promise<GetAllNotificationStatusDTO>
    GetNotificationStatusById(id: string): Promise<NotificationStatusDTO>
}

export function NewNotificationStatusService(): NotificationStatusService {
    return new NotificationStatusServiceImpl()
}